<template>
	<div class="popup" @mousedown.self="$emit('close')">
		<div class="popup__block">
			<div class="popup__top">
				<div class="popup__title"> {{ manager ? "Редактировать" : "Добавить" }} категорийного менеджера</div>
				<div class="popup__close" @click="$emit('close')"></div>
			</div>
			<div class="popup__content">
				<div class="page-label">Контактное лицо</div>
				<div class="form">
					<div class="form__inputs form__inputs--3">
						<InputText :label="'Имя'" :placeholder="'Введите имя'" v-model="formData.name" :errors="v$.formData.name.$errors"/>
						<InputText :label="'Фамилия'" :placeholder="'Введите фамилию'" v-model="formData.lastName" :errors="v$.formData.lastName.$errors"/>
						<InputText :label="'E-mail'" :placeholder="'example@gmail.com'" v-model="formData.email" :errors="v$.formData.email.$errors"/>
					</div>
					<div class="form__inputs">
						<InputMultiplyPhone v-model="formData.phones" :phones="manager?.phones"/>
					</div>
				</div>
				<hr>
				<ProductCategories  v-model="formData.productGroups" :checkedProductGroups="manager?.productGroups"/>
			</div>
			<hr>
			<template v-if="manager">
				<div class="info-list__title page-subtitle">Данные для входа</div>
				<div class="info-list__wrap">
					<InputText :label="'Логин'" :readonly="true" :placeholder="manager.email"/>
					<div class="default-input">
						<div class="default-input__label">Пароль</div>
						<button class="btn btn--border" @click.prevent="sendPassword">Отправить пароль</button>
						<div v-if="passSentDate || manager.passSent" class="default-input__label default-input__label--bottom">Ранее направлен: {{ passSentDate || manager.passSent }}</div>
					</div>
				</div>
				<hr>
			</template>
			<div class="popup__btns">
				<button @click="sendForm" class="btn btn--color">{{ manager ? 'Изменить' : 'Добавить'  }}</button>
			</div>
		</div>
		<PageLoader v-if="isLoading"/>
	</div>

</template>

<script>
import ProductCategories from "@/components/blocks/ProductCategories.vue";
import InputText from "@/components/base/utils/formElements/InputText.vue";
import InputMultiplyPhone from "@/components/base/utils/formElements/InputMultiplyPhone.vue";
import PageLoader from "@/components/base/utils/PageLoader.vue";
import {useToast} from "vue-toastification";
import useVuelidate from "@vuelidate/core";
import {required, helpers, email } from '@vuelidate/validators'
const {withMessage} = helpers
import {mapActions} from "vuex";
import Fetch from "@/utils/Fetch";


export default {
	name: 'AddCategoryManagerPopup',
	components: {ProductCategories,InputText,PageLoader, InputMultiplyPhone},
	props: {
		manager: {
			type: Object,
			default: () => {}
		},
		productGroups: {
			type: Object,
			default: () => {}
		}
	},
	setup() {
		return {
			v$: useVuelidate()
		}
	},
	data() {
		return {
			toast: useToast(),
			isLoading: false,
			PopupTitle: '',
			passSentDate: '',
			formData: {
				id: this.manager?.id || null,
				name: this.manager?.name || '',
				lastName: this.manager?.lastName || '',
				email: this.manager?.email || '',
				phones: this.manager?.phones || '',
				productGroups: [],
				force: ''
			}
		}

	},
	methods: {
		async sendPassword() {
			this.isLoading = true
			let response = await Fetch(`managers/password/send/${this.manager.id}/`, {
				method: 'POST',
			})
			
			if(response.success) {
				this.toast.success(`Пароль успешно отправлен`);
				this.passSentDate = response.data
			} else {
				this.toast.error(response.message);
			}
			this.isLoading = false
		},
		async sendForm() {
			const validated = await this.v$.$validate()
			if (!validated) {
				this.toast.error('Пожалуйста, заполните все поля');
				return
			}
			
			const data = {
				id: this.formData.id,
				name: this.checkFieldChange(this.formData.name, 'name'),
				lastName: this.checkFieldChange(this.formData.lastName, 'lastName'),
				email: this.checkFieldChange(this.formData.email, 'email'),
				phones: this.checkFieldChange(this.formData.phones, 'phones'),
				productGroups: this.formData.productGroups,
				force: this.formData.force
			};

			const response = await this.createManager(data);

			if(response.success) {
				this.toast.success(`Менеджер успешно ${this.manager ? 'изменен' : 'добавлен'}`);
				this.$emit('close')
			}
		},

		checkFieldChange(value, field) {
			if(this.formData.id) {

				if (Array.isArray(value)) {
					if (value.every(el => this.manager?.[field].includes(el))) {
						return null
					}
				}

				if(value != this.manager?.[field]) {
					return this.formData[field]
				} else {
					return null
				}
			}
			return this.formData[field]
		},

		forceUpdate() {
			this.formData.force = 'Y'
			this.sendForm()
		},

		...mapActions({
			createManager: 'categoryManagers/createManager',
		}),
	},
	validations() {
		return {
			formData: {
				name: {
					required: withMessage("Заполните имя", required),
				},
				lastName: {
					required: withMessage("Заполните фамилию", required),
				},
				email: {
					email: withMessage('Неверный формат электронной почты', email),
					required: withMessage('Заполните E-mail', required),
				},
			}
		}
	},
}
</script>
